// src/runtime.ts
var options = window.__VPSS__ || {};
async function hideSplashScreen() {
  if (options.hidden)
    return;
  const id = "vpss";
  const splashScreen = document.getElementById(id);
  const splashScreenStyles = document.getElementById(`${id}-style`);
  if (!splashScreen || !splashScreenStyles) {
    console.error(
      "Splash screen not found. Did you forget to add the `vite-plugin-splash-screen` plugin?"
    );
    return;
  }
  splashScreen.addEventListener("animationend", (event) => {
    if (event.animationName === "vpss-hide") {
      splashScreen.remove();
      splashScreenStyles.remove();
    }
  });
  options.hidden = true;
  if (options["minDurationMs"] !== void 0 && options["renderedAt"] !== void 0) {
    const elapsedTime = (/* @__PURE__ */ new Date()).getTime() - options.renderedAt;
    const remainingTime = Math.max(options.minDurationMs - elapsedTime, 0);
    await new Promise((resolve) => setTimeout(resolve, remainingTime));
  }
  splashScreen.classList.add(`${id}-hidden`);
}
export {
  hideSplashScreen
};
